import React, {
  useMemo,
  forwardRef,
  useRef,
  useContext,
  useImperativeHandle,
  useState,
  useEffect,
} from 'react';
import { Table } from 'antd';
import { useLocation } from 'umi';
import {
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  useTheme,
  Checkbox,
  Button,
  IconButton,
  Box,
  Fab,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import AddIcon from '@material-ui/icons/Add';
import { useIntl } from 'umi';
import { useSelector, useDispatch } from 'dva';
import StoreModal from '@/components/StoreModalML/StoreModal';
import webStorage from '@/utils/storageManager';
import { Context } from '../../AddMarketing';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { TextFieldCom, RadioFieldCom } from '@/components/FormType';
import ModalML from '@/components/ModalML/NewModalML';
import CouponModal from '../operate_modal/coupon_modal/CouponModal';
import TicketModal from '../ticket_modal/ticket_modal/index';
import MemberLevel from './member_level/index';
import AllMemberLevel from './all_member_level/index';
import CommodityRules from './commodity_rules/index';
import CompanyRules from './company_rules/index';
import StoreRules from './store_rules/index';
import ActivityEquityStyled from './ActivityEquityStyled';

const debounce = (fun, delay) => {
  let timer = null;
  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      timer = null;
      fun.apply(this, args);
    }, delay || 500);
  };
};
export default forwardRef((props) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const intl = useIntl();
  const { formatMessage } = intl;
  const location = useLocation();

  const tenantIdTw = webStorage.get('TENANT_ID') === '11076';
  const {
    marketingId,
    levelRulesList: levelRulesListJSONWithStr = [],
    setLevelRulesList,
    benefitType,
    setBenefitType,
    opt,
    hasLevelRule,
    setHasLevelRule,
    isSendCoupon,
    setIsSendCoupon,
    hasProductRule,
    setHasProductRule,
    orderBenefitType,
    setOrderBenefitType,
    isAllCompany,
    setIsAllCompany,
    isAllStore,
    setIsAllStore,
    storesChooseItemShowData,
    setStoresChooseItemShowData,
    companies,
    setCompanies,
    productRulesList,
    setProductRulesList,
    onSubmit,
    id,
    isSendCouponList,
    memberLevel,
    isFirstOrderValid,
    setIsFirstOrderValid,
    allLevelData,
    setAllLevelData = () => {},
    setIsSave,
    orderChannelConditions,
    orderChannelIsLimit,
    orderAmountLimit,
    handleInitEvent,
    handleAddCoupon,
    handleSaveCouponList,
    setCouponId,
    handleDeleteCoupon,
    ticketList,
    setTicketList,
    ticketListSave,
    setTicketListSave,
    setIsAllGoods,
    isAllGoods,
  } = props;
  console.log('isAllGoods', isAllGoods);

  const { ref } = useContext(Context);
  const { handleSubmit, errors, control, getValues, setValue, watch } =
    useForm();

  useEffect(() => {
    setValue('isAllGoods', isAllGoods);
  }, [isAllGoods]);
  const submitRef = useRef();
  const clickInput = () => {
    submitRef.current.click();
  };
  const [couponList, setCouponList] = useState([]);
  const [couponDialogStatus, setCouponDialogStatus] = useState(false);

  const [productDialogStatus, setProductDialogStatus] = useState();

  useImperativeHandle(ref, () => ({
    // handleSubmit 就是暴露给父组件的方法
    clickInput: clickInput,
  }));
  const levelRulesListJSONObj = useMemo(() => {
    let newArr = [];
    if (levelRulesListJSONWithStr) {
      newArr = levelRulesListJSONWithStr;
      newArr.forEach((element) => {
        if (typeof element?.coupons === 'string') {
          const reg = /\\/g;
          element['coupons'] = JSON.parse(element?.coupons?.replace(reg));
        }
      });
    }
    return newArr;
  }, [levelRulesListJSONWithStr]);

  // 处理productRulesList
  const productRulesListJSONObj = useMemo(() => {
    let newArr = [];
    if (productRulesList) {
      newArr = productRulesList;
      newArr.forEach((element) => {
        if (typeof element?.coupons === 'string') {
          const reg = /\\/g;
          element['coupons'] = JSON.parse(element?.coupons?.replace(reg));
        }
      });
    }
    return newArr;
  }, [productRulesList]);

  const levelData = [
    {
      id: 0,
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl01' }),
    },
    {
      id: 1,
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl02' }),
    },
    {
      id: 2,
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl03' }),
    },
    {
      id: 3,
      // name: '送积分',
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl04' }),
    },
    {
      id: 4,
      // name: '送优惠券',
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl05' }),
    },
    {
      id: 5,
      // name: '状态',
      name: formatMessage({ id: 'marketing.scene.holiday.c02.lbl06' }),
    },
  ];

  const levelDataTitle = (
    <span className="level-title-wrap">
      {levelData &&
        levelData.map((title) => {
          return <div>{title.name}</div>;
        })}
    </span>
  );

  const levelGroup = (
    <>
      {levelDataTitle}
      <AllMemberLevel
        id={id}
        opt={opt}
        // memberLevelData={levelRulesListJSONObj}
        // setMemberLevel={setLevelRulesList}
        allLevelData={levelRulesListJSONObj}
        setAllLevelData={setLevelRulesList}
        setIsSave={setIsSave}
      ></AllMemberLevel>
    </>
  );

  const {
    control: storeControl,
    handleSubmit: handleSubmitStore,
    setValue: setValueStore,
    getValues: getValuesStore,
    reset: resetStore,
    watch: watchStore,
  } = useForm();

  // const { register } = useFormContext();
  const [dialogStatus, setDialogStatus] = useState(false); //选中门店model的状态
  // const [storesChooseItemShowData, setStoresChooseItemShowData] = useState([]); //选中的门店点确定后的值列
  const [storesChooseItemData, setStoresChooseItemData] = useState([]); //存储所有选中数据列
  const [storesChooseDataId, setStoresChooseDataId] = useState([]); //选中的门店Id
  const [storesChooseItemShowIdData, setStoresChooseItemShowIdData] = useState(
    [],
  ); //选中的门店点确定后的值Id
  const { storesList, storesPageSize } = useSelector(
    (state) => state.couponsSetting,
  );
  const columns = [
    {
      type: 'checkbox',
      width: '100',
      onChange: (a) => {
        const pageDataIds = storesList.map((item) => item.id); //当前分页的id数组
        const prevStoresChooseItemData = storesChooseItemData.filter((item) => {
          //过滤掉当前页的选中列
          return pageDataIds.indexOf(item.id) === -1;
        });
        let chooseDatas = storesList.filter((fItem) => {
          //当前选中的数据过滤出当前页的数据
          return a.includes(fItem.id);
        });
        const newListData = [...prevStoresChooseItemData, ...chooseDatas];
        //将选中的数据a替换老数据
        const newIdsData = newListData.map((item) => item.id);
        setStoresChooseDataId(newIdsData);
        setStoresChooseItemData(newListData);
      },
    },
    {
      // title: '门店Code',
      title: formatMessage({
        id: 'marketing.scene.holiday.c11.lbl01',
      }),
      id: 'storeNo',
      align: 'center',
      width: 150,
    },
    {
      // title: '门店名称',
      title: formatMessage({
        id: 'marketing.scene.holiday.c11.lbl02',
      }),
      id: 'name',
      align: 'center',
      width: 200,
    },
    {
      title: '门店状态',
      id: 'statusCn',
      align: 'center',
      width: 100,
    },
    {
      title: '门店类型',
      id: 'storeType',
      align: 'center',
      width: 100,
    },
  ];

  const onCloseDialog = (data) => {
    if (data) {
      setStoresChooseItemShowData(storesChooseItemData);
      setStoresChooseItemShowIdData(storesChooseDataId);
    } else {
      setStoresChooseItemData(storesChooseItemShowData);
      setStoresChooseDataId(storesChooseItemShowIdData);
    }
    // setValue(
    //   'stores',
    //   (storesTypeChooseState ?? deStoresTypeChooseState) === '0'
    //     ? JSON.stringify(storesChooseItemData)
    //     : '',
    // );
    setDialogStatus(false);
  };

  const changePageStore = (data) => {
    dispatch({
      type: 'couponsSetting/setStoresPage',
      payload: {
        value: {
          pageNum: data.pageNum,
          pageSize: data.pageSize,
        },
      },
    });
  };

  const onSubmitSuccessStore = (data) => {
    onHandleClickSearchStores(data);
  };

  const onHandleClickSearchStores = (data) => {
    dispatch({
      type: 'couponsSetting/searchStores',
      payload: {
        value: { ...data, pageNum: 1, pageSize: storesPageSize },
      },
    });
  };

  const handleAddStore = () => {
    // 点击打开modal
    setDialogStatus(true);
  };
  const isSendCouponColumns = [
    {
      title: '金额下限',
      dataIndex: 'minAmount',
      key: 'minAmount',
      width: 180,
    },
    {
      title: '金额上线',
      dataIndex: 'maxAmount',
      key: 'maxAmount',
      width: 180,
    },
    {
      title: '优惠券',
      dataIndex: 'coupon',
      key: 'coupon',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 250,
    },
  ];

  const handleSetting = (record) => {
    setCouponDialogStatus(true);
    setCouponList(record.couponInfo);
    setCouponId(record.id);
  };
  const handleCancel = () => {
    setDialogStatus(false);
  };
  const handleSaveCoupon = (data) => {
    handleSaveCouponList(data);
    setCouponDialogStatus(false);
  };

  //点击添加剧目
  const handleClickAdd = () => {
    setProductDialogStatus(true);
  };
  //关闭剧目选择弹窗
  const handleProductCancel = () => {
    setProductDialogStatus(false);
  };

  const handleAddTicket = (selectList) => {
    // Sort selectList by proNo and featureDate+featureTime
    if (watch('isAllGoods') !== '2') {
      const sortedList = [...selectList].sort((a, b) => {
        if (a.proNo === b.proNo) {
          const aDateTime = `${a.featureDate} ${a.featureTime}`;
          const bDateTime = `${b.featureDate} ${b.featureTime}`;
          return new Date(bDateTime) - new Date(aDateTime); // Descending order
        }
        return a.proNo.localeCompare(b.proNo);
      });
      setTicketListSave(sortedList);
      setTicketList(sortedList);
    } else {
      setTicketListSave(selectList);
      setTicketList(selectList);
    }

    setDialogStatus(false);
  };

  const productColumns = [
    ...(watch('isAllGoods') !== 'DESIGNATED_SERIES'
      ? [
          {
            title: '剧目编码',
            dataIndex: 'proNo',
            key: 'proNo',
          },
          {
            title: '剧目名称',
            dataIndex: 'proName',
            key: 'proName',
          },
          {
            title: '场次编码',
            dataIndex: 'featureNo',
            key: 'featureNo',
          },
          {
            title: '场次时间',
            key: 'featureTime',
            dataIndex: 'featureTime',
            render: (_, record) => {
              return `${record.featureDate} ${record.featureTime}`;
            },
          },
          {
            title: '票档',
            key: 'priceNo',
            dataIndex: 'priceNo',
          },
        ]
      : [
          {
            title: '剧目编码',
            dataIndex: 'proNo',
            key: 'proNo',
          },
          {
            title: '剧目名称',
            dataIndex: 'proName',
            key: 'proName',
          },
          {
            title: '演出时间',
            dataIndex: 'featureTime',
            key: 'featureTime',
            width: 220,
            render: (_, record) => {
              return `${record.proStartDate || ''} ${record.proEndDate || ''}`;
            },
          },
        ]),
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <IconButton aria-label="delete" disabled={opt === 'detail'}>
          <SvgIconML
            name="circleDelete"
            size={22}
            fill={
              opt !== 'detail'
                ? theme.palette.primary.main
                : theme.palette.secondary.disabled
            }
            className="preview"
            onClick={() => {
              const key =
                watch('isAllGoods') !== 'DESIGNATED_SERIES' ? 'id' : 'proNo';
              setTicketList(
                ticketList.filter((item) => item[key] !== record[key]),
              );
              setTicketListSave(
                ticketListSave.filter((item) => item[key] !== record[key]),
              );
            }}
          />
        </IconButton>
      ),
    },
  ];
  return (
    <ActivityEquityStyled theme={theme} disabled={opt === 'detail'}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="basic-title">
          {formatMessage({ id: 'marketing.scene.holiday.n02.lbl01' })}
        </div>
        {(marketingId && marketingId.toString() === '3') ||
        location.pathname.includes('bind') ||
        location.pathname.includes('consumption') ||
        location.pathname.includes('level_change') ||
        location.pathname.includes('point_use') ||
        location.pathname.includes('festival') ? (
          <FormControlLabel
            className="checkbox-radio-disabled-color label-title"
            control={
              <Checkbox
                checked={hasLevelRule}
                onChange={(e) => {
                  setHasLevelRule(e.target.checked);
                }}
                name="hasLevelRule"
                color="primary"
              />
            }
            // className="label-title"
            label={formatMessage({ id: 'marketing.scene.holiday.n02.chb02' })}
            disabled={opt === 'detail'}
          />
        ) : (
          <FormLabel component="legend" className="basic-cycle">
            <span className="label-require">*</span>
            {formatMessage({ id: 'marketing.scene.holiday.n02.chb02' })}
          </FormLabel>
        )}
        {(marketingId && marketingId.toString() === '0') ||
        location.pathname.includes('registration') ? (
          <div className="all-level-wrap">{levelGroup}</div>
        ) : (
          // 权益是否相同规则benefitType
          <Controller
            render={(rp) => (
              <RadioGroup
                className="checkbox-radio-disabled-color cycle-select-wrap"
                aria-label="date"
                name="customized-radios"
                onChange={(e) => {
                  setBenefitType(e.target.value);
                  return rp.onChange(e.target.value);
                }}
                value={benefitType}
              >
                <div>
                  <FormControlLabel
                    value="SAME"
                    control={
                      <Radio
                        className="checkbox-radio-disabled-color"
                        color="primary"
                        disabled={opt === 'detail'}
                      />
                    }
                    color="primary"
                    label={formatMessage({
                      id: 'marketing.scene.holiday.n02.rdo03',
                    })}
                    className="all-level-select"
                  />
                </div>
                {/* 全部等级 */}
                {levelDataTitle}
                <AllMemberLevel
                  opt={opt}
                  id={id}
                  allLevelData={allLevelData}
                  setAllLevelData={setAllLevelData}
                  setIsSave={setIsSave}
                ></AllMemberLevel>
                <div>
                  <FormControlLabel
                    value="NOT_SAME"
                    control={
                      <Radio
                        className="checkbox-radio-disabled-color"
                        color="primary"
                        disabled={opt === 'detail'}
                      />
                    }
                    color="primary"
                    label={formatMessage({
                      id: 'marketing.scene.holiday.n03.rdo01',
                    })}
                    className="different-level-select"
                  />
                </div>
                {levelDataTitle}
                {/* 不同等级 */}
                <MemberLevel
                  opt={opt}
                  id={id}
                  errors={errors}
                  memberLevelData={
                    levelRulesListJSONObj?.length > 1
                      ? levelRulesListJSONObj
                      : memberLevel
                  }
                  // setMemberLevel={
                  //   benefitType === 'NOT_SAME' ? setLevelRulesList : () => {}
                  // }
                  setMemberLevel={setLevelRulesList}
                  setIsSave={setIsSave}
                ></MemberLevel>
              </RadioGroup>
            )}
            control={control}
            name="benefitType"
          />
        )}
        {/* 新增首单按钮 */}
        {/* 生日，会员日，节日 */}
        {location.pathname.includes('registration') === false && (
          <div className="first-order-wrap">
            <FormLabel component="legend" className="first-cycle">
              <span className="label-require">*</span>
              {formatMessage({ id: 'marketing.scene.holiday.n04.lbl01' })}
            </FormLabel>
            <Controller
              render={(rp) => (
                <RadioGroup
                  className="checkbox-radio-disabled-color first-select-wrap"
                  aria-label="date"
                  name="customized-radios"
                  onChange={(e) => {
                    setIsFirstOrderValid(e.target.value);
                    return rp.onChange(e.target.value);
                  }}
                  value={isFirstOrderValid}
                >
                  <FormControlLabel
                    value="0"
                    control={
                      <Radio
                        className="checkbox-radio-disabled-color"
                        color="primary"
                        disabled={opt === 'detail'}
                      />
                    }
                    color="primary"
                    label={formatMessage({
                      id: 'marketing.scene.holiday.n04.rdo02',
                    })}
                    className="first-order"
                  />
                  <FormControlLabel
                    value="1"
                    control={
                      <Radio
                        className="checkbox-radio-disabled-color"
                        color="primary"
                        disabled={opt === 'detail'}
                      />
                    }
                    color="primary"
                    label={formatMessage({
                      id: 'marketing.scene.holiday.n04.rdo03',
                    })}
                    className="first-order"
                  />
                  {/* <FormControlLabel
                    value="2"
                    control={
                      <Radio
                        className="checkbox-radio-disabled-color"
                        color="primary"
                        disabled={opt === 'detail'}
                      />
                    }
                    color="primary"
                    label="消费折扣，积分回馈和送积分适用于会员全渠道第一笔订单"
                    className="first-order"
                  /> */}
                </RadioGroup>
              )}
              control={control}
              name="benefitType"
            />
          </div>
        )}
        {location.pathname.includes('repurchase') ? (
          <div style={{ marginTop: '40px' }}>
            <RadioFieldCom
              errors={errors}
              control={control}
              getValues={getValues}
              setValue={setValue}
              disabled={opt === 'detail'}
              initLabel="适用范围"
              label="适用范围"
              name="isAllGoods"
              defaultValue={isAllGoods}
              labelRow="flex"
              typeList={[
                { label: '全部可用', value: 'ALL_GOODS' },
                { label: '指定剧目可触发', value: 'DESIGNATED_SERIES' },
                { label: '指定票档可触发', value: 'DESIGNATED_GOODS' },
              ]}
              callback={(value) => {
                setTicketListSave([]);
                setTicketList([]);
                setIsAllGoods(value);
              }}
            ></RadioFieldCom>
            {watch('isAllGoods') !== 'ALL_GOODS' && (
              <Box mb={5}>
                <Box mb={2}>
                  <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="add"
                    sx={{ marginRight: '16px' }}
                    onClick={handleClickAdd}
                    disabled={opt === 'detail'}
                  >
                    <AddIcon
                      sx={{ width: '24px', height: '24px', fill: '#fff' }}
                    />
                    添加
                  </Fab>
                </Box>
                <Table
                  columns={productColumns}
                  dataSource={ticketListSave}
                  size="small"
                />
              </Box>
            )}
          </div>
        ) : (
          ''
        )}

        {!location.pathname.includes('repurchase') ? (
          <div>
            <FormControlLabel
              className="checkbox-radio-disabled-color label-title"
              style={{ marginTop: '40px' }}
              control={
                <Checkbox
                  checked={isSendCoupon}
                  onChange={(e) => {
                    setIsSendCoupon(e.target.checked);
                  }}
                  name="isSendCoupon"
                  color="primary"
                />
              }
              // className="label-title"
              label="消费返券"
              disabled={opt === 'detail'}
            />
            <Table
              columns={isSendCouponColumns.map((col) => ({
                ...col,
                render: (text, record, index) => {
                  if (col.dataIndex === 'minAmount') {
                    return (
                      <div style={{ width: '120px' }}>
                        <TextFieldCom
                          control={control}
                          label=""
                          name={`min_${record.id}`}
                          isNumber={true}
                          isPositiveNumber={true}
                          isParseInt={true}
                          defaultValue={record.minAmount}
                          getValues={getValues}
                          setValue={setValue}
                          errors={errors}
                          rules={{ required: true }}
                          handleInitEvent={debounce(handleInitEvent, 1000)}
                          disabled={opt === 'detail'}
                        />
                      </div>
                    );
                  } else if (col.dataIndex === 'maxAmount') {
                    return (
                      <div style={{ width: '120px' }}>
                        <TextFieldCom
                          control={control}
                          label=""
                          name={`max_${record.id}`}
                          isNumber={true}
                          isPositiveNumber={true}
                          isParseInt={true}
                          defaultValue={record.maxAmount}
                          getValues={getValues}
                          setValue={setValue}
                          errors={errors}
                          rules={{ required: true }}
                          handleInitEvent={debounce(handleInitEvent, 1000)}
                          disabled={opt === 'detail'}
                        />
                      </div>
                    );
                  } else if (col.dataIndex === 'coupon') {
                    return (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <SvgIconML
                          name={'coupon'}
                          className={
                            record?.couponNum > 0 ? 'coupon' : 'noCoupon'
                          }
                        ></SvgIconML>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                          }}
                        >
                          <div style={{ width: '160px' }}>
                            <TextFieldCom
                              control={control}
                              label=""
                              name={`couponNum_${record.id}`}
                              isNumber={true}
                              isPositiveNumber={true}
                              isParseInt={true}
                              defaultValue={record.couponNum}
                              getValues={getValues}
                              setValue={setValue}
                              errors={errors}
                              rules={{ required: true }}
                              handleInitEvent={debounce(handleInitEvent, 1000)}
                              disabled={opt === 'detail'}
                            />
                          </div>
                          {/* 张 */}
                          {formatMessage({ id: 'comm.chart.lbl.10' })}
                        </span>
                        {/* 点击设置打开弹窗 */}
                        <Button
                          onClick={() => handleSetting(record)}
                          disabled={opt === 'detail'}
                          className={
                            record?.couponInfo?.length > 0 && opt !== 'detail'
                              ? 'coupon-settings coupons'
                              : 'coupon-settings noCoupons'
                          }
                        >
                          {formatMessage({
                            id: 'marketing.scene.holiday.c02.txt01',
                          })}
                        </Button>
                      </div>
                    );
                  }
                  return (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                      }}
                    >
                      {isSendCouponList.length > 1 && (
                        <IconButton
                          aria-label="delete"
                          disabled={opt === 'detail'}
                        >
                          <SvgIconML
                            name="circleDelete"
                            size={22}
                            fill={
                              opt !== 'detail'
                                ? theme.palette.primary.main
                                : theme.palette.secondary.disabled
                            }
                            className="preview"
                            onClick={() => {
                              handleDeleteCoupon(record.id);
                            }}
                          />
                        </IconButton>
                      )}
                      {index === isSendCouponList.length - 1 &&
                        opt !== 'detail' && (
                          <IconButton
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            color="inherit"
                            disabled={opt === 'detail'}
                          >
                            <AddCircleOutlineIcon
                              size={26}
                              fill={
                                opt !== 'detail'
                                  ? theme.palette.primary.main
                                  : theme.palette.secondary.disabled
                              }
                              onClick={handleAddCoupon}
                            />
                          </IconButton>
                        )}
                    </div>
                  );
                },
              }))}
              dataSource={isSendCouponList}
              size="small"
              pagination={false}
            />
          </div>
        ) : (
          ''
        )}

        {location.pathname.includes('birthday') ||
          (location.pathname.includes('member') && (
            <StoreRules
              getValues={getValues}
              setValue={setValue}
              errors={errors}
              control={control}
              watch={watch}
              opt={opt}
              id={id}
              isAllStore={isAllStore}
              setIsAllStore={setIsAllStore}
              setDialogStatus={setDialogStatus}
              storesChooseItemShowData={storesChooseItemShowData || []}
              setStoresChooseItemShowData={setStoresChooseItemShowData}
              setStoresChooseItemShowIdData={setStoresChooseItemShowIdData}
              setStoresChooseItemData={setStoresChooseItemData}
              setStoresChooseDataId={setStoresChooseDataId}
              storesChooseDataId={storesChooseDataId}
              storesChooseItemData={storesChooseItemData}
              storesChooseItemShowIdData={storesChooseItemShowIdData}
              orderChannelConditions={orderChannelConditions}
              orderChannelIsLimit={orderChannelIsLimit}
              handleAddStore={handleAddStore}
            ></StoreRules>
          ))}
        {location.pathname.includes('festival') && (
          <>
            {!tenantIdTw && (
              <CommodityRules
                orderAmountLimit={orderAmountLimit}
                opt={opt}
                dataId={id}
                orderBenefitType={orderBenefitType}
                setOrderBenefitType={setOrderBenefitType}
                hasProductRule={hasProductRule}
                setHasProductRule={setHasProductRule}
                productRulesList={productRulesListJSONObj}
                setProductRulesList={setProductRulesList}
                setIsSave={setIsSave}
                setFormValue={setValue}
                getValues={getValues}
                errors={errors}
                watch={watch}
                control={control}
              ></CommodityRules>
            )}
            <CompanyRules
              opt={opt}
              dataId={id}
              isAllCompany={isAllCompany}
              setIsAllCompany={setIsAllCompany}
              companies={companies || []}
              setCompanies={setCompanies}
              setIsSave={setIsSave}
            ></CompanyRules>
            <StoreRules
              getValues={getValues}
              setValue={setValue}
              errors={errors}
              control={control}
              watch={watch}
              opt={opt}
              id={id}
              isAllStore={isAllStore}
              setIsAllStore={setIsAllStore}
              setDialogStatus={setDialogStatus}
              storesChooseItemShowData={storesChooseItemShowData || []}
              setStoresChooseItemShowData={setStoresChooseItemShowData}
              setStoresChooseItemShowIdData={setStoresChooseItemShowIdData}
              setStoresChooseItemData={setStoresChooseItemData}
              setStoresChooseDataId={setStoresChooseDataId}
              storesChooseDataId={storesChooseDataId}
              storesChooseItemData={storesChooseItemData}
              storesChooseItemShowIdData={storesChooseItemShowIdData}
              orderChannelConditions={orderChannelConditions}
              orderChannelIsLimit={orderChannelIsLimit}
              handleAddStore={handleAddStore}
            ></StoreRules>
          </>
        )}
        <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
      </form>
      {!location.pathname.includes('repurchase') ? (
        <StoreModal
          dialogStatus={dialogStatus}
          title="选择门店"
          chooseIds={storesChooseItemShowIdData}
          columns={columns}
          control={storeControl}
          getValues={getValuesStore}
          setValue={setValueStore}
          watch={watchStore}
          changePage={changePageStore}
          onCloseDialog={onCloseDialog}
          handleSubmit={handleSubmitStore}
          onSubmitSuccess={onSubmitSuccessStore}
          reset={resetStore}
        />
      ) : (
        ''
      )}
      <ModalML
        open={couponDialogStatus}
        setOpen={setCouponDialogStatus}
        onCancel={handleCancel}
        title="选择优惠券"
        onConfirm={handleSaveCoupon}
        onClose={handleCancel}
      >
        <CouponModal
          open={couponDialogStatus}
          control={control}
          setOpen={setCouponDialogStatus}
          onConfirm={handleSaveCoupon}
          couponList={couponList}
        ></CouponModal>
      </ModalML>

      <ModalML
        open={productDialogStatus}
        setOpen={setProductDialogStatus}
        onCancel={handleProductCancel}
        title={
          watch('isAllGoods') === 'DESIGNATED_SERIES' ? '选择剧目' : '选择票档'
        }
        onConfirm={handleAddTicket}
        onClose={handleProductCancel}
      >
        <TicketModal
          open={productDialogStatus}
          control={control}
          setOpen={setProductDialogStatus}
          onConfirm={handleAddTicket}
          couponList={ticketList}
          setTicketList={setTicketList}
          showType={watch('isAllGoods')}
        ></TicketModal>
      </ModalML>
    </ActivityEquityStyled>
  );
});
